<div class="card shadow">
  <div class="card-body">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div>
        <p class="mb-0 text-secondary">Assign every checklist and display current status.</p>
        <button class="btn btn-outline-primary mt-2" (click)="exportToExcel()">
          <i class="bi bi-file-earmark-spreadsheet me-1"></i>Export Excel
        </button>
      </div>
      <div class="legend-container">
        <span class="me-3">Legend</span>
        <div class="d-inline-block me-3">
          <span class="status-indicator failed"></span>
          <span>Test Failed</span>
        </div>
        <div class="d-inline-block me-3">
          <span class="status-indicator pending"></span>
          <span>Test Pending</span>
        </div>
        <div class="d-inline-block">
          <span class="status-indicator passed"></span>
          <span>Test Passed</span>
        </div>
      </div>
    </div>

    <div class="list-group mt-2">
      <div class="list-group-item p-2 bg-light">
        <div class="row g-2">
          <div class="col-md-1"><label class="fw-bold">#</label></div>
          <div class="col-md-2"><label class="fw-bold">Checklist</label></div>
          <div class="col-md-3"><label class="fw-bold">Workinglist Name</label></div>
          <div class="col-md-2"><label class="fw-bold">Platform</label></div>
          <div class="col-md-2"><label class="fw-bold">Assign To</label></div>
          <div class="col-md-2"></div>
        </div>
      </div>
      @for (item of checklist; track item; let i = $index) {
        <div class="list-group-item p-2" [ngClass]="getStatusClass(item.status)">
          <div class="row g-2">
            <div class="col-md-1">
              <div class="checklist-number">{{i + 1}}</div>
            </div>
            <div class="col-md-2">
              <input-field [inputFormControl]="getFormControl(checklistForms[item.projectChecklistId ?? i], 'checklist')"
                [readonly]="true"/>
            </div>
            <div class="col-md-3">
              <input-field [inputFormControl]="getFormControl(checklistForms[item.projectChecklistId ?? i], 'workinglistName')"
                [readonly]="true"/>
            </div>
            <div class="col-md-2">
              <input-field [inputFormControl]="getFormControl(checklistForms[item.projectChecklistId ?? i], 'platform')"
                [readonly]="true"/>
            </div>
            <div class="col-md-2">
              <select-field [selectFormControl]="getFormControl(checklistForms[item.projectChecklistId ?? i], 'assignTo')"
                [options]="employeeOptions"
                (valueChange)="onAssignToChange(item, $event)"/>
            </div>
            <div class="col-md-2">
              <div class="d-flex gap-1">
                <button class="btn btn-primary flex-grow-1" (click)="createTestlist(item)" [disabled]="isCreateTestlistDisabled(item, i)" title="Create Testlist">
                  Create Testlist
                </button>
                <button class="btn btn-danger" (click)="requestDeleteItem(item, i)" title="Delete item">
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
